import type { ReactNode } from 'react';

import { Provider as AuthProvider } from '@/context/AuthContext';
import { Provider as BookAppointmentProvider } from '@/context/BookAppointmentContext';
import { ConsentFormsContextMain } from '@/context/ConsentFormsContext';
import { Provider as ConsentManagerProvider } from '@/context/ConsentManagerContext';
import { Provider as DoctorsContext } from '@/context/DoctorsContext';
import { Provider as DocumentProvider } from '@/context/DocumentContext';
import { Provider as HealthProfileProvider } from '@/context/HealthProfileContext';
import { Provider as HealthProfileContextMain } from '@/context/HealthProfileContextMain';
import { Provider as HealthProfileOverviewProvider } from '@/context/HealthProfileOverviewContext';
import { Provider as ProductProvider } from '@/context/ProductContext';
import { Provider as ResetPaswdContext } from '@/context/ResetPaswdContext';

const AppProviders = ({ children }: { children: ReactNode }) => (
    <DocumentProvider>
        <ResetPaswdContext>
            <ConsentFormsContextMain>
                <HealthProfileContextMain>
                    <HealthProfileOverviewProvider>
                        <ConsentManagerProvider>
                            <DoctorsContext>
                                <BookAppointmentProvider>
                                    <HealthProfileProvider>
                                        <ProductProvider>
                                            <AuthProvider>{children}</AuthProvider>
                                        </ProductProvider>
                                    </HealthProfileProvider>
                                </BookAppointmentProvider>
                            </DoctorsContext>
                        </ConsentManagerProvider>
                    </HealthProfileOverviewProvider>
                </HealthProfileContextMain>
            </ConsentFormsContextMain>
        </ResetPaswdContext>
    </DocumentProvider>
);

export default AppProviders;
